import Vue from 'vue';
import Swiper from '@/components/global/Swiper/Swiper.vue';
import SwiperSlide from '@/components/global/Swiper/SwiperSlide';
import moment from 'moment';
import { mapGetters } from 'vuex';
const formatTimeNumber = (num) => ('' + num).length < 2 ? '0' + num : '' + num;
function setActiveSwiperSlide(swiper, content) {
    const slides = swiper.slides;
    for (let i = 0; i < slides.length; i++) {
        if (slides[i].textContent === content) {
            slides[i].classList.add('selected-slide');
        }
        else {
            slides[i].classList.remove('selected-slide');
        }
    }
}
const normalizeDate = (date) => date.split('.').reverse().join('-');
const isValidDate = (date) => {
    return date.search(/[А-Яа-я]/g) < 0 && moment(normalizeDate(date)).isValid();
};
const isValidTime = (time) => moment(time).isValid();
function setTimePickerLimits() {
    const now = this.maxDateTime;
    const h = moment(now).format('HH');
    const m = moment(now).format('mm');
    if (this.datePicker.selectedDate === moment(now).format('YYYY-MM-DD')) {
        for (const hour of this.timePicker.hours) {
            hour.enabled = +hour.value <= +h;
        }
        if (this.timePicker.selectedHours === h) {
            for (const minute of this.timePicker.minutes) {
                minute.enabled = +minute.value <= +m;
            }
        }
        else {
            for (const minute of this.timePicker.minutes) {
                minute.enabled = true;
            }
        }
    }
    else {
        for (const hour of this.timePicker.hours) {
            hour.enabled = true;
        }
        for (const minute of this.timePicker.minutes) {
            minute.enabled = true;
        }
    }
}
export default Vue.extend({
    name: 'dateTimePicker',
    props: {
        value: {
            type: Object,
            required: true
        },
        to: {
            type: Object
        },
        isFrom: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        iter: 0,
        timePicker: {
            opened: false,
            hours: [],
            minutes: [],
            selectedMinutes: '00',
            selectedHours: '00'
        },
        datePicker: {
            opened: false,
            minDate: '',
            maxDate: '',
            selectedDate: ''
        },
        disabled: false
    }),
    computed: Object.assign(Object.assign({ getDate: {
            get() {
                return moment(this.value).format('DD.MM.YYYY');
            },
            set(value) {
                if (isValidDate(value)) {
                    if (moment(normalizeDate(value)).isAfter(moment(this.maxDateTime))) {
                        this.datePicker.selectedDate = moment(this.maxDateTime).format('YYYY-MM-DD');
                        this.timePicker.selectedHours = moment(this.maxDateTime).format('HH');
                        this.timePicker.selectedMinutes = moment(this.maxDateTime).format('mm');
                        this.emitDateTime();
                    }
                    else {
                        this.datePicker.selectedDate = normalizeDate(value);
                        this.emitDateTime();
                    }
                }
            }
        }, getTime: {
            get() {
                return moment(this.value).format('HH:mm');
            },
            set(value) {
                if (isValidTime(moment().format('YYYY-MM-DD') + 'T' + value)) {
                    this.timePicker.selectedHours = value.split(':')[0];
                    this.timePicker.selectedMinutes = value.split(':')[1];
                    this.emitDateTime();
                }
            }
        } }, mapGetters('dateTimeModule', ['getNowDateTime'])), { maxDateTime() {
            if (this.getNowDateTime) {
                if (this.isFrom) {
                    return moment(this.to).subtract('1', 'days');
                }
                return moment(this.getNowDateTime);
            }
            else
                return '';
        },
        minDateTime() {
            if (!this.isFrom)
                return moment(this.to).add('1', 'days');
            return '1970-01-01';
        } }),
    watch: {
        maxDateTime: {
            handler: setTimePickerLimits,
            deep: true
        },
        'timePicker.selectedHours': {
            handler: setTimePickerLimits,
            deep: false
        },
        'datePicker.selectedDate': {
            handler: setTimePickerLimits,
            deep: false
        },
        to(v) {
            if (this.isFrom) {
                if (moment(v).subtract('1', 'days').isBefore(moment(this.datePicker.selectedDate))) {
                    this.datePicker.selectedDate = moment(v).subtract('1', 'days').format('YYYY-MM-DD');
                    this.timePicker.selectedHours = moment(v).format('HH');
                    this.timePicker.selectedMinutes = moment(v).format('mm');
                    this.emitDateTime();
                }
            }
        }
    },
    methods: {
        handleKeyPressDate() {
            if (isValidDate(this.datePicker.selectedDate)) {
                this.$emit('goToNextInput');
            }
        },
        handleKeyPressTime() {
            if (isValidTime(moment().format('YYYY-MM-DD') + 'T' + this.timePicker.selectedHours + ':' + this.timePicker.selectedMinutes)) {
                this.$emit('goToNextInput');
            }
        },
        addFocusClass(event) {
            event.target.classList.add('focused');
        },
        removeFocusClass(event) {
            this.iter++;
            event.target.classList.remove('focused');
        },
        handleClickHour(swiper, event) {
            if (swiper.clickedSlide.getAttribute('disabled')) {
                event.preventDefault();
            }
            else {
                this.timePicker.selectedHours = swiper.clickedSlide.textContent;
                setActiveSwiperSlide.call(this, swiper, swiper.clickedSlide.textContent);
            }
        },
        handleClickMinute(swiper, event) {
            if (swiper.clickedSlide.getAttribute('disabled')) {
                event.preventDefault();
            }
            else {
                this.timePicker.selectedMinutes = swiper.clickedSlide.textContent;
                setActiveSwiperSlide.call(this, swiper, swiper.clickedSlide.textContent);
            }
        },
        handleHoursSwiperInit() {
            const { hoursSwiper } = this.$refs;
            const swiper = hoursSwiper.swiperInstance;
            setActiveSwiperSlide.call(this, swiper, this.timePicker.selectedHours);
            let index = null;
            for (let i = 0; i < swiper.slides.length; i++) {
                if (index === null) {
                    if (swiper.slides[i].classList.contains('selected-slide')) {
                        index = swiper.slides[i].dataset.swiperSlideIndex;
                    }
                }
            }
            if (index !== null) {
                swiper.slideToLoop(index, 1);
                setTimeout(() => {
                    swiper.slideToLoop(index++, 500);
                }, 11);
            }
        },
        handleMinutesSwiperInit() {
            const { minutesSwiper } = this.$refs;
            const swiper = minutesSwiper.swiperInstance;
            setActiveSwiperSlide.call(this, minutesSwiper.swiperInstance, this.timePicker.selectedMinutes);
            let index = null;
            for (let i = 0; i < swiper.slides.length; i++) {
                if (index === null) {
                    if (swiper.slides[i].classList.contains('selected-slide')) {
                        index = swiper.slides[i].dataset.swiperSlideIndex;
                    }
                }
            }
            swiper.slideToLoop(index, 1);
            if (index !== null) {
                swiper.slideToLoop(index, 1);
                setTimeout(() => {
                    swiper.slideToLoop(index++, 500);
                }, 11);
            }
        },
        setTime() {
            this.timePicker.opened = false;
        },
        setDate() {
            this.datePicker.opened = false;
            this.emitDateTime();
        },
        emitDateTime() {
            const result = this.datePicker.selectedDate + ' ' + this.timePicker.selectedHours + ':' + this.timePicker.selectedMinutes;
            if (moment(result).isValid()) {
                const dateTime = moment(result);
                this.$emit('input', dateTime);
            }
        }
    },
    created() {
        const vm = this;
        const buildHoursAndMinutesArrays = () => {
            for (let i = 0; i <= 23; i++) {
                const hoursRangeItem = {
                    value: formatTimeNumber(i),
                    enabled: true
                };
                vm.timePicker.hours.push(hoursRangeItem);
            }
            for (let i = 0; i <= 59; i++) {
                const minutesRangeItem = {
                    value: formatTimeNumber(i),
                    enabled: true
                };
                vm.timePicker.minutes.push(minutesRangeItem);
            }
        };
        buildHoursAndMinutesArrays();
        this.datePicker.selectedDate = moment(this.value).format('YYYY-MM-DD');
        this.timePicker.selectedHours = moment(this.value).format('HH');
        this.timePicker.selectedMinutes = moment(this.value).format('mm');
    },
    mounted() {
        setTimePickerLimits.call(this);
    },
    components: {
        Swiper,
        SwiperSlide
    }
});
